/**
 * Blog Product Embeds
 * Findet <div data-product-handle="..."> in Blog-Artikeln
 * und lädt Produktkarten per Section Rendering API nach.
 */
(function () {
	"use strict";

	const SECTION_ID = "blog-product-card";

	function loadProductCards() {
		const placeholders = document.querySelectorAll("[data-product-handle]");
		if (!placeholders.length) return;

		placeholders.forEach(async (placeholder) => {
			const handle = placeholder.getAttribute("data-product-handle");
			if (!handle) return;

			placeholder.classList.add("blog-product-loading");

			try {
				// ENTSCHEIDEND: Fetch im Kontext der Produktseite
				// Dadurch ist das product-Objekt in Liquid verfügbar
				const response = await fetch(`/products/${handle}?section_id=${SECTION_ID}`);

				if (!response.ok) throw new Error(`HTTP ${response.status}`);

				// section_id gibt direkt HTML zurück (kein JSON)
				const html = await response.text();

				const temp = document.createElement("div");
				temp.innerHTML = html;
				const card = temp.querySelector(".blog-product-embed-card");

				if (card) {
					placeholder.innerHTML = card.outerHTML;
					placeholder.classList.remove("blog-product-loading");
					placeholder.classList.add("blog-product-loaded");
				} else {
					placeholder.remove();
				}
			} catch (error) {
				console.warn(`Blog Product Embed: "${handle}" nicht gefunden.`, error);
				placeholder.remove();
			}
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", loadProductCards);
	} else {
		loadProductCards();
	}
})();
